import { AnalyticsBrowser } from '@segment/analytics-next'
import { deviceIdPromise } from '@/src/common/hooks/useDeviceId/deviceIdPromise'

const segmentClient = AnalyticsBrowser.load({
  writeKey: process.env.EXPO_PUBLIC_SEGMENT_WRITE_CLIENT ?? '',
})

export type WebSegmentClient = typeof segmentClient

void deviceIdPromise.then(segmentClient.setAnonymousId)

type MobileSegment = typeof import('./index')

export const identify: MobileSegment['identify'] = async (...args) => {
  await segmentClient.identify(...args)
}

export const flush: MobileSegment['flush'] = () => Promise.resolve()

export const screen: MobileSegment['screen'] = (name, properties) =>
  segmentClient.screen(undefined, name, properties)

export const alias: MobileSegment['alias'] = async (newUserId) => {
  await segmentClient.alias(newUserId)
}

export const reset: MobileSegment['reset'] = async () => {
  await segmentClient.reset()
}

export const track: MobileSegment['track'] = async (event, properties) => {
  await segmentClient.track(event, properties)
}

export const addAppsFlyerPlugin: MobileSegment['addAppsFlyerPlugin'] = () => {}

export * from '@/src/services/segment/triggerSegmentEvents'
